import { useMutation } from '@tanstack/react-query';
import { updatePassword } from '@services/settings';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

type UpdatePasswordArgs = {
  previousPassword: string;
  newPassword: string;
  rememberMe?: boolean;
};

export const useUpdatePassword = () => {
  const tActionMessages = useTranslation('actionMessages');
  return useMutation({
    mutationFn: ({
      previousPassword,
      newPassword,
      rememberMe,
    }: UpdatePasswordArgs) =>
      updatePassword(previousPassword, newPassword, rememberMe),
    onSuccess: () => {
      toast.success(tActionMessages.passwordUpdatedSuccessfully);
    },
    onError: (error: any) => {
      const message =
        error?.response?.data?.errorMessage ||
        error?.message ||
        tActionMessages.requestError;
      toast.error(message);
    },
  });
};

export default useUpdatePassword;
